import { render, staticRenderFns } from "./modifyLogistics.vue?vue&type=template&id=b1377194&scoped=true"
import script from "./modifyLogistics.vue?vue&type=script&lang=js"
export * from "./modifyLogistics.vue?vue&type=script&lang=js"
import style0 from "./modifyLogistics.vue?vue&type=style&index=0&id=b1377194&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1377194",
  null
  
)

export default component.exports